/* eslint-disable */
import { IconProps } from "@/components/ui/Icons";
import React from "react";
import { isMobile } from 'react-device-detect';
import Image from "next/image";
import { first, second, third } from '@/public/img/tournaments';

const Podium = ({
  FirstPrizeComponent,
  SecondPrizeComponent,
  ThirdPrizeComponent,
}: IconProps & {
  FirstPrizeComponent: React.ReactNode;
  SecondPrizeComponent: React.ReactNode;
  ThirdPrizeComponent: React.ReactNode;
}) => {
  return (
    <div className={`relative pb-6  mx-3 flex ${isMobile ? 'gap-2' : 'gap-6'}`}>
      <div className="flex flex-col justify-center items-center">
        <Image src={second} alt="first" width={isMobile ? 80 : 150} height={isMobile ? 80 : 150} />
        {SecondPrizeComponent}
      </div>

      <div className="flex flex-col justify-center items-center">
        <Image src={first} alt="first" width={isMobile ? 100 : 180} height={isMobile ? 100 : 180} />
        {FirstPrizeComponent}
      </div>

      <div className="flex flex-col justify-center items-center">
        <Image src={third} alt="first" width={isMobile ? 75 : 140} height={isMobile ? 75 : 140} />
        {ThirdPrizeComponent}
      </div>
    </div>
  );
};

export default Podium;